/* RESPONSIBLE TEAM: team-automation-foundations */
import IntercomRoute from 'embercom/routes/base/intercom-route';

export default class AutomationFinAIAgentCustomAnswersAnswerShowIndexRoute extends IntercomRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.custom-answers.answer.show.index',
  };
}
